import { Component, Injector, Type, ViewChild } from '@angular/core';
import { SatPopoverComponent } from '@ncstate/sat-popover';

@Component({
  selector: 'sg-click-confirm-popover-container',
  template: `<span [satPopoverAnchor]="popover"></span>
    <sat-popover #popover>
      <ng-container *ngComponentOutlet="component; injector: injector"></ng-container>
    </sat-popover>`,
  host: {
    '[style.display]': `'none'`,
  },
  standalone: false,
})
export class SgClickConfirmPopoverContainer {
  component: Type<any>;
  injector: Injector;
  @ViewChild(SatPopoverComponent, { static: true }) satPopover: SatPopoverComponent;
}
